require('./bootstrap')

import Timing from './Timing'

shared.sendError = () => {}

new Timing()
